import axios from "axios";
import { defineStore } from "pinia";
import { sendAppointmentNote } from "./../libs/notesHelper";

const defaultState = {
  events: [],
  _activeRange: [],
  removedEvents: [],
  prefilledCustomer: null,
};
export const useEventStore = defineStore("event", {
  state: () => ({ ...defaultState }),
  getters: {
    getEvents(state) {
      // Only return actual array items, not temp event properties
      return state.events.filter((_, idx) => typeof idx === 'number');
    },
    getEvent(state) {
      return (eventId) => {
        // Check if it's a temp event stored as property
        if (typeof eventId === 'string' && eventId.startsWith('temp-')) {
          return state.events[eventId];
        }
        // Otherwise look in the array
        return state.events.find((event) => event.id === eventId);
      };
    },
    getRemovedEvents() {
      return this.removedEvents;
    },
    getRemovedEventsCount() {
      return this.removedEvents.length;
    },
  },
  actions: {
    addEvent(event) {
      if (event.is_deleted === true) {
        this.removedEvents.push(event);
      } else {
        this.events = [...this.events, event];
      }
    },
    removeEvent(eventId, cancellationNote = '') {
      const removedEvent = this.events.filter((event) => event.id === eventId);
      this.events = this.events.filter((event) => event.id !== eventId);
      this.removedEvents.push(removedEvent[0]);

      // Send note for appointment cancellation
      if (removedEvent[0]) {
        sendAppointmentNote(
          removedEvent[0].customer,
          'Appointment cancelled',
          cancellationNote,
          {
            id: removedEvent[0].id,
            service_id: removedEvent[0].service_id
          }
        ).catch(err => console.error('Failed to send cancellation note:', err));
      }

      axios
        .delete(`/api/bookings/${eventId}`)
        .then((response) => console.log(response));
    },
    updateEvent(event) {
      const index = this.events.findIndex((el) => el.id === event.id);
      if (index !== -1) {
        this.events[index] = event;
        axios.put(`/api/bookings/${event.id}`, event).then((response) => {
          console.log(response);
        });
      }
    },
    addActiveRange(date) {
      this._activeRange.push(date);
    },
    reset() {
      Object.assign(this, defaultState);
    },
  },
});
